export const antdTheme = {
  colorPrimary: '#3C64B1',
  borderRadius: '4px',
}
